import { useEffect, useState } from 'react';
import { useAppStore } from '@/hooks/useAppStore';
import HomeHeader from './components/HomeHeader';
import HeroBanner from './components/HeroBanner';
import AIToolsGrid from './components/AIToolsGrid';
import InspirationGrid from './components/InspirationGrid';
import ModelEntryCards from './components/ModelEntryCards';
import { track } from '@/utils/tracker';

export default function Home() {
  const { user, authInitialized } = useAppStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    track.homeView();
  }, []);

  return (
    <div className="min-h-dvh font-nunito" style={{ background: 'linear-gradient(160deg, #FFF5F9 0%, #F8F3FF 50%, #F3F6FF 100%)' }}>
      <div className="relative max-w-md mx-auto min-h-dvh flex flex-col">
        {/* 导航栏 */}
        <HomeHeader user={user} authInitialized={authInitialized} />

        {/* 内容区 */}
        <div
          className="flex-1 overflow-y-auto ios-scroll pb-36"
          style={{
            opacity: mounted ? 1 : 0,
            transition: 'opacity 0.5s ease',
          }}
        >
          {/* Banner */}
          <HeroBanner />

          {/* 精选模型 */}
          <ModelEntryCards />

          {/* 创作工具 */}
          <div className="mt-5">
            <AIToolsGrid />
          </div>

          {/* 作品广场 */}
          <div className="mt-6">
            <InspirationGrid />
          </div>
        </div>
      </div>
    </div>
  );
}
